// Logistics bucket — route departing soon (§5.7 / SC-9 defer).
//
// Structural stub: `useLogisticsRouteDepartingCount` returns 0 until
// `logisticsRoutes` scheduled-window data lands. Registry declares
// `hasSignal: () => false` so the dock never peeks on fabricated data.

/**
 * Stub data source. Returns routes with a dispatch window starting soon.
 * Future slice replaces this with `useLogisticsRoutesPanel` aggregates.
 */
function useLogisticsRouteDepartingCount(): number {
  return 0;
}

export function ActivityDockLogisticsRouteDepartingSection() {
  const count = useLogisticsRouteDepartingCount();

  if (count <= 0) return null;

  return (
    <section
      aria-label="Logistics route departing reminder"
      className="mt-3 rounded-lg border border-red-300 bg-red-50 p-3 dark:border-red-500/60 dark:bg-red-950/30"
    >
      <h3 className="text-[11px] font-semibold uppercase tracking-wide text-red-900 dark:text-red-200">
        Routes departing soon
      </h3>
      <p className="mt-1 text-[12px] text-red-900 dark:text-red-200">
        {count} {count === 1 ? "route is" : "routes are"} scheduled to depart
        within the dispatch window. Review stops in Logistics → Routes.
      </p>
    </section>
  );
}
